var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#EC4646"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11386_13824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8039 52.2625C50.413 52.6534 49.7789 52.6529 49.3886 52.2614L44.0352 46.891C43.6449 46.4994 43.0109 46.4989 42.6199 46.8899L37.2486 52.2611C36.8571 52.6526 36.2221 52.6515 35.832 52.2587L34.169 50.5841C33.7808 50.1931 33.7819 49.5619 34.1714 49.1723L39.5273 43.8165C39.9178 43.426 39.9178 42.7928 39.5273 42.4023L34.1739 37.0489C33.7834 36.6584 33.7834 36.0252 34.1739 35.6347L36.1972 33.6114C36.5877 33.2209 37.2209 33.2209 37.6114 33.6114L42.9659 38.9659C43.356 39.356 43.9883 39.3565 44.379 38.967L49.7538 33.6092C50.1445 33.2197 50.7768 33.2202 51.1669 33.6103L52.8261 35.2695C53.2166 35.66 53.2166 36.2931 52.8261 36.6837L47.4524 42.0574C47.0614 42.4484 47.0619 43.0824 47.4535 43.4727L52.8239 48.8261C53.2154 49.2164 53.2159 49.8505 52.825 50.2414L50.8039 52.2625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8039 52.2625C50.413 52.6534 49.7789 52.6529 49.3886 52.2614L44.0352 46.891C43.6449 46.4994 43.0109 46.4989 42.6199 46.8899L37.2486 52.2611C36.8571 52.6526 36.2221 52.6515 35.832 52.2587L34.169 50.5841C33.7808 50.1931 33.7819 49.5619 34.1714 49.1723L39.5273 43.8165C39.9178 43.426 39.9178 42.7928 39.5273 42.4023L34.1739 37.0489C33.7834 36.6584 33.7834 36.0252 34.1739 35.6347L36.1972 33.6114C36.5877 33.2209 37.2209 33.2209 37.6114 33.6114L42.9659 38.9659C43.356 39.356 43.9883 39.3565 44.379 38.967L49.7538 33.6092C50.1445 33.2197 50.7768 33.2202 51.1669 33.6103L52.8261 35.2695C53.2166 35.66 53.2166 36.2931 52.8261 36.6837L47.4524 42.0574C47.0614 42.4484 47.0619 43.0824 47.4535 43.4727L52.8239 48.8261C53.2154 49.2164 53.2159 49.8505 52.825 50.2414L50.8039 52.2625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11386_13824",
    x: 21.5451,
    y: 32.3174,
    width: 43.9074,
    height: 43.9047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11386_13824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11386_13824",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.d828317a28ee79870e38972b7ac4bc55.svg";
export { ForwardRef as ReactComponent };